module.exports = __webpack_public_path__ + "img/x-circle.c2ade009.svg";